module.exports = __webpack_public_path__ + "790118a2f42dc6292fda76b1c40ab92d.MP3";